import { ProductWithQuantity } from '../model';
import { GTMTrackChangeBasket, GTMCartItem } from '../model/TrackingObject';

export type MiniBasketAddToBasketEvent = {
    event: 'eec_add';
    ecommerce: {
        currencyCode?: string;
        basket_id: string;
        detail: {
            actionField: { list: 'Minibasket' };
            products: ProductWithQuantity[];
        };
        cartItems?: GTMCartItem[];
    };
};

export const trackMiniBasketAddToBasketEvent = ({
    products,
    currencyCode,
    cartItems,
    basketId
}: GTMTrackChangeBasket): MiniBasketAddToBasketEvent => ({
    event: 'eec_add',
    ecommerce: {
        basket_id: basketId,
        currencyCode,
        detail: {
            actionField: { list: 'Minibasket' },
            products,
        },
        cartItems
    },
});
